<template>
<div class="container">
  <div class="main__body" v-if="list!=null">
    <div class="news__list__container">
      <div class="list__item" v-for="(item,index) in list" :key="index" @click="$utils.jump(`/newsDetail/${item.id}`)">
        <MList :item="item" />
      </div>
      <div class="load__wrapper" v-if="loading==true">
        <Load />
      </div>
      <div class="list__end" v-if="page==totalPage && loading==false">
        <span>已经到底啦...</span>
      </div>
      <van-empty description="暂无内容" v-if="list.length==0 && loading==false" />
    </div>
  </div>
</div>
</template>
<script>
import MList from "@/components/MList";
import {
  mapActions
} from 'vuex'
export default {
  data() {
    return {
      page: 1,
      pageSize: 15,
      totalPage: null,
      list: null,
      loading: true,
      catId:null
    }
  },
  components: {
    MList
  },
  computed: {},
  created() {
    scrollTo(0, 0)
  },
  methods: {
    init(catId) {
      scrollTo(0, 0)
      this.list = null
      this.page = 1
      this.catId=catId
      this.getList()
    },
    loadMore() {
      let {
        page,
        totalPage,
        loading
      } = this
      if (loading) {
        return false
      }
      if (totalPage != null) {
        if (page < totalPage) {
          this.page++
          this.getList();
        }
      }
    },
    async getList() {
      let self = this
      let {
        page,
        pageSize,
        list,
        catId
      } = self
      self.loading = true
      let posData = {
        data: {
          page,
          pageSize,
          catId
        }
      }
      if (list != null) {
        posData.loadMsg = false
      }
      let res = await this._getArticleList(posData)
      self.loading = false
      if (res && res.code == 200) {
        if (list == null) {
          self.list = res.data.list
        } else {
          self.list.push(...res.data.list)
        }
        self.totalPage = res.data.totalPage
      }
    },
    ...mapActions('api', ['_getArticleList'])
  }
}
</script>
<style lang="less" scoped>
.container {
    .main__body {
        min-height: calc(100vh - 50px);
        padding-bottom: 50px;
    }
}
</style>
